<footer class="footer-main">
  <!-- Faixa Laranja Superior -->
  <div class="footer-accent-line"></div>

  <div class="container-layout pt-6 pb-6">
    <div class="grid">
      
      <!-- 1. Coluna Marca e Social -->
      <div class="col-12 lg:col-4 mb-5 lg:mb-0">
        <div class="flex flex-column align-items-center lg:align-items-start gap-4 pr-0 lg:pr-6 text-center lg:text-left">
          <img 
            ngSrc="assets/images/logo-vetor.svg" 
            alt="Seu Ingresso Aqui" 
            width="200" 
            height="40"
            class="mb-2"
          />
          
          <p class="text-gray-400 text-sm line-height-3 m-0">
            A plataforma definitiva para gestão de eventos e venda de ingressos. Tecnologia de ponta e segurança total para organizadores e participantes em todo o Brasil.
          </p>

          <div class="flex gap-2 mt-2 justify-content-center lg:justify-content-start">
            <a href="https://www.instagram.com/seuingressoaqui.br" target="_blank" rel="noopener noreferrer" class="social-btn" aria-label="Instagram">
              <i class="pi pi-instagram"></i>
            </a>
            <a href="https://facebook.com/seuingressoaqui" target="_blank" rel="noopener noreferrer" class="social-btn" aria-label="Facebook">
              <i class="pi pi-facebook"></i>
            </a>
            <a href="https://wa.me/5534999469600?text=Ol%C3%A1%2C%20preciso%20de%20ajuda" target="_blank" rel="noopener noreferrer" class="social-btn" aria-label="WhatsApp">
              <i class="pi pi-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- 2. Coluna Institucional -->
      <div class="col-12 sm:col-6 lg:col-2 mb-5 lg:mb-0 text-center lg:text-left">
        <div class="flex flex-column align-items-center lg:align-items-start">
          <h3 class="footer-title">INSTITUCIONAL</h3>
          <nav class="flex flex-column gap-3 align-items-center lg:align-items-start">
            <a href="/termos-de-uso" (click)="openInstitutionalDialog('terms', $event)" class="footer-link">Termos de Uso</a>
            <a href="/politica-de-privacidade" (click)="openInstitutionalDialog('privacy', $event)" class="footer-link">Privacidade</a>
            <a href="/quem-somos" (click)="openInstitutionalDialog('about', $event)" class="footer-link">Quem Somos</a>
          </nav>
        </div>
      </div>

      <!-- 3. Coluna Suporte -->
      <div class="col-12 sm:col-6 lg:col-2 mb-5 lg:mb-0 text-center lg:text-left">
        <div class="flex flex-column align-items-center lg:align-items-start">
          <h3 class="footer-title">SUPORTE</h3>
          <nav class="flex flex-column gap-3 align-items-center lg:align-items-start">
            <a href="#" (click)="openModalLogin(0, $event)" class="footer-link">Minha Conta</a>
            <a href="#" (click)="openModalLogin(1, $event)" class="footer-link">Meus Eventos</a>
            <a href="#" (click)="openHelpChat($event)" class="footer-link">Ajuda</a>
          </nav>
        </div>
      </div>

      <!-- 4. Coluna Pagamento e Segurança -->
      <div class="col-12 lg:col-4 text-center lg:text-left">
        <div class="flex flex-column align-items-center lg:align-items-start">
          <h3 class="footer-title">PAGAMENTO & SEGURANÇA</h3>
          
          <div class="flex flex-column gap-4 align-items-center lg:align-items-start w-full">
            <!-- Bandeiras -->
            <div class="w-full flex flex-column align-items-center lg:align-items-start">
              <span class="text-xs text-gray-500 font-bold uppercase mb-3 block tracking-wider">Bandeiras Aceitas</span>
              <div class="flex flex-wrap gap-3 justify-content-center lg:justify-content-start">
                
                <!-- Visa -->
                <div class="payment-card" pTooltip="Visa" tooltipPosition="top">
                  <img ngSrc="assets/icons/visa.svg" width="36" height="12" alt="Visa" class="w-full h-full object-contain" />
                </div>
                
                <!-- Mastercard (Corrigido path) -->
                <div class="payment-card" pTooltip="Mastercard" tooltipPosition="top">
                  <img ngSrc="assets/images/master-brand.png" width="36" height="22" alt="Mastercard" class="w-full h-full object-contain" />
                </div>
                
                <!-- Amex -->
                <div class="payment-card" pTooltip="American Express" tooltipPosition="top">
                  <img ngSrc="assets/icons/american-express.svg" width="36" height="22" alt="Amex" class="w-full h-full object-contain" />
                </div>
                
                <!-- Elo / Outros -->
                <div class="payment-card" pTooltip="Outros Cartões" tooltipPosition="top">
                  <i class="pi pi-credit-card text-gray-600 text-xl"></i>
                </div>
                
                <!-- PIX -->
                <div class="payment-card bg-green-500 border-none" pTooltip="Pagamento via PIX" tooltipPosition="top">
                  <span class="text-white font-extrabold text-xs">PIX</span>
                </div>
              </div>
            </div>

            <!-- Selos de Segurança -->
            <div class="p-3 border-1 border-white-alpha-10 border-round-lg bg-white-alpha-5 flex align-items-center gap-3 w-full max-w-20rem lg:max-w-none transition-colors hover:bg-white-alpha-10 cursor-default">
              <div class="w-2rem h-2rem border-circle bg-green-500_10 flex align-items-center justify-content-center">
                <i class="pi pi-lock text-green-500 text-xl"></i>
              </div>
              <div class="flex flex-column text-left">
                <span class="font-bold text-sm text-white mb-1">SAFE CHECKOUT</span>
                <span class="text-xs text-gray-400">Ambiente 100% seguro e criptografado</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Rodapé Inferior -->
  <div class="footer-bottom">
    <div class="container-layout h-full">
      <div class="flex flex-column md:flex-row align-items-center justify-content-between h-full py-4 gap-3">
        
        <!-- Copyright e Logo Peq -->
        <div class="flex align-items-center gap-3">
          <div class="flex align-items-center gap-2 opacity-40 hover:opacity-60 transition-opacity transition-duration-300">
            <i class="pi pi-ticket"></i>
            <span class="text-xs font-bold tracking-wider uppercase">Seu Ingresso Aqui</span>
          </div>
          <div class="hidden md:block divider-vertical"></div>
          <span class="bottom-text text-xs text-center md:text-left">
            &copy; {{ currentYear }} SEU INGRESSO AQUI
          </span>
        </div>

        <!-- Info Técnica -->
        <div class="flex flex-column md:flex-row align-items-center gap-2 md:gap-4 text-center md:text-left">

          <span class="bottom-text text-xs font-bold opacity-60">CNPJ: 64.381.084/0001-33</span>
        </div>

      </div>
    </div>
  </div>
</footer>
